import styled from 'styled-components';
import { media } from '../../styles/media';

export const Title = styled.div`
  text-align: center;
  margin-bottom: 48px;
  
  h2 {
    font-size: 52px;
    font-weight: 650;
    line-height: 1.2;
    margin: 0;
    color: ${props => props.theme.colors.text.heading};
    display: inline;
    
    &:not(:last-child) {
      margin-right: 12px;
    }
  }

  .highlight {
    color: ${props => props.$color || '#1ABC9C'};
    background: ${props => props.$bgColor || 'rgba(26, 188, 156, 0.1)'};
    padding: 0.25rem 1rem;
    border-radius: 100px;
    display: inline-block;
  }
  
  ${media.xl`
    h2 {
      font-size: 48px;
    }
  `}
  
  ${media.lg`
    h2 {
      font-size: 42px;
    }
  `}
  
  ${media.md`
    margin-bottom: 32px;
    
    h2 {
      font-size: 36px;
      
      &:not(:last-child) {
        margin-right: 8px;
      }
    }
  `}
  
  ${media.sm`
    h2 {
      font-size: 28px;
      word-break: break-word;
      
      // Для коротких заголовков оставляем в строку
      display: ${props => props.$inlineOnMobile ? 'inline' : 'block'};
      
      &:not(:last-child) {
        margin-right: ${props => props.$inlineOnMobile ? '8px' : '0'};
        margin-bottom: ${props => props.$inlineOnMobile ? '0' : '8px'};
      }
    }
    
    .highlight {
      padding: 0.2rem 0.8rem;
    }
  `}
`; 